module.exports = __webpack_public_path__ + "img/icon-post-pen-white.0576004.svg";